import { render, staticRenderFns } from "./ConfirmAccount.vue?vue&type=template&id=9b3640cc&scoped=true&"
import script from "./ConfirmAccount.vue?vue&type=script&lang=js&"
export * from "./ConfirmAccount.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAccount.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ConfirmAccount.vue?vue&type=style&index=1&id=9b3640cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b3640cc",
  null
  
)

export default component.exports